import React from 'react'

const WIDTH = 35
const HEIGHT = 42
// สีเดียวกับเส้นทางรถโม่เล็กห้ามเข้าในหน้า smartdispatching (route type 2) เพื่อให้ผู้ใช้โยงข้อมูลชุดเดียวกันได้
const COLOR = '#F53C56'

// หมุดเส้นทางรถโม่ห้ามเข้า — วาดด้วย SVG ไม่ต้องรอไฟล์ PNG
// ทรงหมุดและสัดส่วนอิงตัวเดียวกับ RiskPointMarker (จุดปลายหาง y ≈ 42 ตรงกับ offset { x: 17, y: 42 })
const MixerTruckProhibitedRouteMarker = ({
  width = WIDTH,
  height = HEIGHT,
  color = COLOR,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 35 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ display: 'block' }}
  >
    <path d="M11.6 28.2 L17.5 41.6 L23.4 28.2 Z" fill={color} />
    <circle
      cx="17.5"
      cy="16.4"
      r="14.9"
      fill="#ffffff"
      stroke={color}
      strokeWidth="2.6"
    />
    <g
      transform="translate(17.5 16.4) scale(0.78) translate(-12 -12)"
      stroke={color}
      strokeWidth="2.3"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    >
      <circle cx="12" cy="8.6" r="5.4" />
      <line x1="8.6" y1="8.6" x2="15.4" y2="8.6" />
      <line x1="4.6" y1="21.4" x2="9.4" y2="15.2" />
      <line x1="19.4" y1="21.4" x2="14.6" y2="15.2" />
      <line x1="12" y1="21.4" x2="12" y2="19.4" />
      <line x1="12" y1="17.8" x2="12" y2="16.4" />
    </g>
  </svg>
)

export default MixerTruckProhibitedRouteMarker
